import { createTypes, createAsyncTypes } from '../../utils';

const prefix = 'customer';

const types = createTypes(prefix, [
    'SET_COUNTRY',
    'UPDATE_NEWSLETTER_ERROR'
]);

const asyncTypes = createAsyncTypes(prefix, [
    'FETCH_MYFILTER',
    'UPDATE_MYFILTER',
    'SUBSCRIBE_TO_NEWSLETTER'
]);

export default {
    ...types,
    ...asyncTypes
};
